import { useContext } from 'react';
import { UserContext } from '../../Context/UserContext/UserContext';
import { Button, useMediaQuery } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import { Language } from '@material-ui/icons';

export const ChangeLocaleButton: React.FC = () => {
  const user = useContext(UserContext);
  const isXs = useMediaQuery((theme) => (theme as any).breakpoints.only('xs'));

  const changeLocale = () => {
    user.changeLocale(user.locale === 'sv' ? 'en' : 'sv');
  };

  return (
    <Button
      variant="text"
      color="inherit"
      onClick={changeLocale}
      startIcon={<Language />}
    >
      {!isXs ? (
        <FormattedMessage
          id="component.change-locale-button.changeLanguage"
          defaultMessage="Change language"
          description="Label for Change language-button"
        />
      ) : (
        <FormattedMessage
          id="component.home.language"
          defaultMessage="EN"
          description="Current language"
        />
      )}
    </Button>
  );
};
